"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localSourceSelector = localSourceSelector;
var _Sources = require("@studio/constants/Sources");
/**
 * Selectors for the local broadcast source
 * @param state
 * @returns {*}
 */
function localSourceSelector(state) {
  var _broadcastSources$sou;
  var user = state.user,
    broadcastSources = state.broadcastSources;
  return (_broadcastSources$sou = broadcastSources.sources) === null || _broadcastSources$sou === void 0 ? void 0 : _broadcastSources$sou.find(function (source) {
    return source.user === (user === null || user === void 0 ? void 0 : user._id) && source.value !== _Sources.UNASSIGNED;
  });
}